import classNames from "classnames";

import {CheckboxProps} from "@/components/checkbox/Checkbox.types.ts";
import {CheckboxInput} from "@/components/checkbox/CheckboxInput/CheckboxInput.tsx";
import {CheckboxLabel} from "@/components/checkbox/CheckboxLabel/CheckboxLabel.tsx";

import styles from "./Checkbox.module.scss";

const CheckboxComponent = ({className, children, id, label, disabled, helpText, ...rest}: CheckboxProps) => {
  return (
    <div className={classNames(styles.checkboxRoot, className)}>
      {children || (
        <>
          <CheckboxInput id={id!} disabled={disabled} {...rest} />
          {label && (
            <CheckboxLabel forId={id!} helpText={helpText} disabled={disabled}>
              {label}
            </CheckboxLabel>
          )}
        </>
      )}
    </div>
  );
};

CheckboxComponent.displayName = "Checkbox";

export const Checkbox = Object.assign(CheckboxComponent, {
  Input: CheckboxInput,
  Label: CheckboxLabel,
});
